import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'client-no-stock',
  templateUrl: './client-no-stock.component.html',
  styleUrls: ['./client-no-stock.component.scss']
})
export class ClientNoStockComponent {
  @Input()
  isDoubleSided: boolean = false;

  @Output()
  intendOrderStock = new EventEmitter<{
    intendOrderStock: boolean;
    autoSelectNoStock: boolean;
  }>();

  orderStock(): void {
    this.intendOrderStock.emit({
      intendOrderStock: true,
      autoSelectNoStock: false
    });
  }

  selectNoStock(): void {
    this.intendOrderStock.emit({
      intendOrderStock: false,
      autoSelectNoStock: true
    });
  }

  close(): void {
    this.intendOrderStock.emit({
      intendOrderStock: false,
      autoSelectNoStock: false
    });
  }
}
